export var TrackingV1;
(function (TrackingV1) {
    let TrackingEventType;
    (function (TrackingEventType) {
        TrackingEventType["AdViewed"] = "AdViewed";
        TrackingEventType["PostCreated"] = "PostCreated";
        TrackingEventType["PostLiked"] = "PostLiked";
        TrackingEventType["CommentCreated"] = "CommentCreated";
        TrackingEventType["DiscountRedeemed"] = "DiscountRedeemed";
        TrackingEventType["BusinessClaimed"] = "BusinessClaimed";
        TrackingEventType["EventAttended"] = "EventAttended";
    })(TrackingEventType = TrackingV1.TrackingEventType || (TrackingV1.TrackingEventType = {}));
})(TrackingV1 || (TrackingV1 = {}));
